import React from 'react'

export const RecurringEvents = React.lazy(
  () => import(/* webpackChunkName: "recurring-events-modal" */ '../modals/recurring-events'),
)
